import dayjs from "dayjs"
import { t } from "i18next"
import { useEffect, useMemo, useState } from "react"

export type PERIOD_VALUES = 'TOTAL' | 'LAST_TWO_YEARS' | 'LAST_YEAR' | 'CURRENT_YEAR' | 'SEMESTER' | 'THREE_MONTS'

export type PERIODS = { key: string, value: PERIOD_VALUES }[]

export const usePeriodSelector = () => {

    const [period, setPeriod] = useState<PERIOD_VALUES>('TOTAL')

    const periods: PERIODS = [
        {
            key: t('period:quarter'),
            value: 'THREE_MONTS',
        },
        {
            key: t('period:semester'),
            value: 'SEMESTER',
        },
        {
            key: t('period:currentYear'),
            value: 'CURRENT_YEAR',
        },
        {
            key: t('period:lastYear'),
            value: 'LAST_YEAR',
        },
        {
            key: t('period:lastTwoYears'),
            value: 'LAST_TWO_YEARS',
        },
        {
            key: t('period:total'),
            value: 'TOTAL',
        },
    ]

    const dateFromPeriod = useMemo(() => {
        switch (period) {
            case 'TOTAL':
                return undefined
            case 'SEMESTER':
                return dayjs().subtract(6, 'months').toISOString()
            case 'LAST_TWO_YEARS':
                return dayjs().subtract(2, 'year').toISOString()
            case 'THREE_MONTS':
                return dayjs().subtract(3, 'months').toISOString()
            case 'LAST_YEAR':
                return dayjs().subtract(1, 'year').toISOString()
            case 'CURRENT_YEAR':
                return dayjs().startOf('year').toISOString()

            default:
                return undefined
        }

    }, [period])

    return {
        periods,
        period,
        setPeriod,
        dateFromPeriod
    }
}